// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__UOYo5","inputSuccess":"FieldCurrencyInput_inputSuccess__3xCKx","inputError":"FieldCurrencyInput_inputError__gtsGK"};